import React from 'react';
import './Ticker.css';
import { motion } from 'framer-motion';

const Ticker = () => {
  const items = Array(10).fill("SHOP IN-STORE");

  return (
    <div className="ticker-section">
      <motion.div 
        className="ticker-content"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
      >
        {items.map((item, index) => (
          <span key={index} className="ticker-item">{item}</span>
        ))}
        {items.map((item, index) => (
          <span key={`clone-${index}`} className="ticker-item">{item}</span>
        ))}
      </motion.div>
    </div>
  );
};

export default Ticker;
